import { render, staticRenderFns } from "./ChangeTmpPwdView.vue?vue&type=template&id=0b61f924&scoped=true&"
import script from "./ChangeTmpPwdView.vue?vue&type=script&lang=js&"
export * from "./ChangeTmpPwdView.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTmpPwdView.vue?vue&type=style&index=0&id=0b61f924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61f924",
  null
  
)

export default component.exports